//统一管理api
import { base_bome } from "./base"; // 导入接口域名列表
import { post } from "./tool"; // 导入http中创建的axios实例

//meme100list
export const getMeme100List = (params) => post(base_bome + "/newgame/coin/token_created", params);
export default {
    getMeme100List,
};
